var render = function render(_c,_vm){return _c('div',{staticClass:"not-found-page"},[_c('h1',[_vm._v("Sorry - we couldn't find that page")]),_c('p',[_vm._v("Please double check your link - this one is incorrect!")]),_c('p',[_vm._v("If you need to login, "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("click here.")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }